import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@abp/ng.core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CoreModule as CaCoreModule } from 'src/core/core.module';
import { TagSelectorModule } from 'src/ui/tag-selector/tag-selector.module';
import { UserSelectorModule } from 'src/ui/user-selector/user-selector.module';
import { DepartmentSelectorModule } from 'src/ui/department-selector/department-selector.module';
import { IconsModule } from 'src/ca-shared/icons/icons.module';

import { QueryDetailBuilderComponent } from '../query/query-detail/query-detail-builder/query-detail-builder.component';
import { QueryTreeNodeFactoryComponent } from '../query/query-tree-node-factory/query-tree-node-factory.component';
import { QueryTreeNodeTagComponent } from '../query/query-builder-nodes/query-tree-node-tag/query-tree-node-tag.component';
import { QueryTreeNodeUserSelectorComponent } from '../query/query-builder-nodes/query-tree-node-user-selector/query-tree-node-user-selector.component';
import { QueryTreeNodeDepartmentTreeComponent } from '../query/query-builder-nodes/query-tree-node-department-tree/query-tree-node-department-tree.component';
import { QueryBuilderNodeRemoveButtonComponent } from '../query/query-builder-node-remove-button/query-builder-node-remove-button.component';
import { QueryBuilderNodeDuplicateButtonComponent } from '../query/query-builder-node-duplicate-button/query-builder-node-duplicate-button.component';

@NgModule({
  declarations: [
    QueryDetailBuilderComponent,
    QueryTreeNodeFactoryComponent,
    QueryTreeNodeTagComponent,
    QueryTreeNodeUserSelectorComponent,
    QueryTreeNodeDepartmentTreeComponent,
    QueryBuilderNodeRemoveButtonComponent,
    QueryBuilderNodeDuplicateButtonComponent,
  ],
  imports: [
    CommonModule,
    CoreModule,
    CaCoreModule,
    ThemeSharedModule,
    ReactiveFormsModule,
    FormsModule,
    NgbDropdownModule,
    NgbTooltipModule,
    MatTreeModule,
    MatIconModule,
    MatButtonModule,
    MatSlideToggleModule,
    TagSelectorModule,
    UserSelectorModule,
    DepartmentSelectorModule,
    IconsModule,
  ],
  exports: [
    QueryDetailBuilderComponent,
    QueryTreeNodeFactoryComponent,
    QueryTreeNodeTagComponent,
    QueryTreeNodeUserSelectorComponent,
    QueryTreeNodeDepartmentTreeComponent,
    QueryBuilderNodeRemoveButtonComponent,
    QueryBuilderNodeDuplicateButtonComponent,
  ],
})
export class QueryEditorModule {}
